import { render, staticRenderFns } from "./pages2_1.vue?vue&type=template&id=d94aab48&scoped=true&"
import script from "./pages2_1.vue?vue&type=script&lang=js&"
export * from "./pages2_1.vue?vue&type=script&lang=js&"
import style0 from "./pages2_1.vue?vue&type=style&index=0&id=d94aab48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94aab48",
  null
  
)

export default component.exports